import {
  IL1StandardBridge,
  IL1StandardBridge__factory,
  L1DepositHelper,
  L1DepositHelper__factory,
} from "../../codegen";
import { CONTRACT_ADDRESSES } from "../../constants/addresses";
import { ChainIdEnum } from "../../enums/chain";

export const getL1DepositHelperContract = (
  provider?: any,
  chainId?: ChainIdEnum
): L1DepositHelper | undefined => {
  const signerOrProvider = provider?.getSigner() || provider;
  if (signerOrProvider && chainId) {
    const chainAddresses = CONTRACT_ADDRESSES[chainId];
    if (chainAddresses?.l1DepositHelper) {
      return L1DepositHelper__factory.connect(
        chainAddresses.l1DepositHelper,
        signerOrProvider
      );
    }
  }

  return undefined;
};

export const getL1BridgeContract = (
  provider?: any,
  chainId?: ChainIdEnum
): IL1StandardBridge | undefined => {
  const signerOrProvider = provider?.getSigner() || provider;
  if (signerOrProvider && chainId) {
    const chainAddresses = CONTRACT_ADDRESSES[chainId];
    if (chainAddresses?.l1StandardBridge) {
      return IL1StandardBridge__factory.connect(
        chainAddresses.l1StandardBridge,
        signerOrProvider
      );
    }
  }

  return undefined;
};

export const l2GasLimit = 400000;
export const l1GasLimit = 650000;
export const getGasLimit = (chainId?: number) =>
  chainId === ChainIdEnum.SEPOLIA_TESTNET ? l1GasLimit : l2GasLimit;
